import { Component } from 'react';

import { withTranslation } from 'react-i18next';

type Props = {};
type State = {};

class ServiceTerms extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    return (
      <div style={{ padding: 20 }}>
        <h1>Terms and Conditions</h1>
        <p>Last updated: June 30, 2024</p>
        <p>
          Please read these Terms and Conditions ("Terms", "Terms and Conditions") carefully before using the Square Golf website (the "Service") operated by Square Golf ("us", "we", or "our").
        </p>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using our Service, you agree to be bound by these Terms. If you disagree with any part of the terms, then you may not access the Service.
        </p>
        <h2>2. Use of the Service</h2>
        <p>
          You agree to use the Service only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use and enjoyment of the Service. Prohibited behavior includes harassing or causing distress or inconvenience to any other user, transmitting obscene or offensive content, or disrupting the normal flow of dialogue within the Service.
        </p>
        <h2>3. Intellectual Property</h2>
        <p>
          The Service and its original content, features, and functionality are and will remain the exclusive property of Square Golf and its licensors. The content is protected by copyright, trademark, and other laws of both the United States and foreign countries.
        </p>
        <h2>4. Termination</h2>
        <p>
          We may terminate or suspend your access to the Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the Service will cease immediately.
        </p>
        <h2>5. Limitation of Liability</h2>
        <p>
          In no event shall Square Golf, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your access to or use of or inability to access or use the Service; (ii) any conduct or content of any third party on the Service; (iii) any content obtained from the Service; and (iv) unauthorized access, use, or alteration of your transmissions or content.
        </p>
        <h2>6. Changes</h2>
        <p>
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion. By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.
        </p>
        <h2>7. Contact Us</h2>
        <p>
          If you have any questions about these Terms, please contact us at 
          <a href='mailto:helpdesk@squaregolf.com'> helpdesk@squaregolf.com </a>
        </p>
      </div>
    );
  }
}

export default withTranslation()(ServiceTerms);
